module.exports = __webpack_public_path__ + "media/images/icons/menu-toggle-896ef4330e3cd9cfaabf433028ee77df.svg";